import baguetteBox from "baguettebox.js";

export default function lightboxDestroy() {
  if (document.getElementById("baguetteBox-overlay")) {
    baguetteBox.destroy();
  }
}
